module.exports = __webpack_public_path__ + "static/media/image6.897429c6.png";